/**
 * Shared helper for OPBridge doc-store (`/docs/{consumer}/{doc_id}`) sync
 * modules — `layout/projectSync.ts`, `autotune/docSync.ts` (removed 2026-09-28),
 * `matrix/matrixSync.ts`. Each maintains its own base_rev cache and retries
 * once on a 409 (optimistic-concurrency conflict) by adopting the server's
 * rev out of the error body. Extracted here once a third caller needed the
 * same four lines rather than letting a fourth copy appear.
 */

import type { OpbridgeError } from './httpClient.ts';

/** Parse `server_rev` out of a 409 OpbridgeError's message. Returns null if
 *  the error body didn't carry one (shouldn't happen for a real 409, but
 *  callers treat null as "can't recover, give up this round" rather than
 *  assuming a shape that might not hold). */
export function parseServerRev(err: OpbridgeError): number | null {
  const m = /"server_rev"\s*:\s*(\d+)/.exec(err.message);
  return m ? parseInt(m[1]!, 10) : null;
}
